// extracted by mini-css-extract-plugin
export default {"subtitulo":"ServicioEdit_subtitulo__AQ3ty","spinnerContainer":"ServicioEdit_spinnerContainer__b2cgt"};